// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateDocument_wrapper__eaU1R","cardContainer":"CreateDocument_cardContainer__fVHaa","formContainer":"CreateDocument_formContainer__EIGbO"};